import { Table } from "@/components";
import type { PerformanceTabData } from "@/hooks/usePerformanceSectionData";
import type * as summaryStyles from "./SummaryTab.css";
import * as styles from "./Tables.css";

type Props = {
	data: PerformanceTabData["summary"];
	styleVariants?: summaryStyles.WrapVariants;
};
export default function AnnualisedTab({ data, styleVariants }: Props) {
	const annualisedData = data.annualised.data.map((row, i) => [
		`${data.cumulative.data[i].at(0)}`,
		...row,
	]);
	const annualisedHeaders = [
		`${data.cumulative.headers.at(0)}`,
		...data.annualised.headers,
	];
	return (
		<div className={styles.wrap()}>
			<Table
				data={annualisedData}
				headers={annualisedHeaders}
				className={styles.table}
				scroll
			/>
		</div>
	);
}
